/**
 * Format number with a thousand separator dots
 * @param {number|string} value - The value to format
 * @returns {string} Formatted number with a thousand separator dots
 * @example
 * formatNumber(1000) => "1.000"
 * formatNumber(1000000) => "1.000.000"
 */
export function formatNumber(value) {
  return value
  // if (!value && value !== 0) return '0';
  // const num = typeof value === 'string'
  //   ? parseFloat(value.replace(/\./g, '').replace(/,/g, ' ').replace(/\s/g, ''))
  //   : num;
  // if (isNaN(num)) return '0';
  // // Auto format with thousand separator dots
  // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

// Map DB value (tiếng Việt) -> nhãn hiển thị (ngắn)
// - Guarantee lưu 'Bảo hành' / 'IQC' (ngắn)
// - Deliver lưu 'Trả bảo hành' / 'Trả IQC' (đầy đủ)
const PROD_TYPE_LABEL = {
  'Bảo hành': 'Bảo hành',
  IQC: 'IQC',
  'Trả bảo hành': 'Bảo hành',
  'Trả IQC': 'IQC',
  'Sản xuất mới': 'Sản xuất mới',
}

export function prodTypeLabel(value) {
  if (value === undefined || value === null) return ''
  return PROD_TYPE_LABEL[value] !== undefined ? PROD_TYPE_LABEL[value] : value
}

// Map từ nhãn GuaEdit (Bảo hành / IQC) sang DB value khi giao hàng (Trả bảo hành / Trả IQC)
// Được dùng khi tạo deliver từ GuaEdit
const GUARANTEE_TO_DELIVER = {
  'Bảo hành': 'Trả bảo hành',
  IQC: 'Trả IQC',
}

export function guaranteeToDeliverType(label) {
  if (!label) return 'Trả bảo hành'
  return GUARANTEE_TO_DELIVER[label] || label
}

// Map từ DB value về nhãn GuaEdit (Trả bảo hành -> Bảo hành)
const DELIVER_TO_GUARANTEE = {
  'Trả bảo hành': 'Bảo hành',
  'Trả IQC': 'IQC',
}

export function deliverToGuaranteeType(value) {
  if (!value) return 'Bảo hành'
  return DELIVER_TO_GUARANTEE[value] || value
}
